// Moved out of component for better performance and to satisfy Sonar
export const customItemRender = (page, type, originalElement, PreviousIcon, NextIcon) => {
    if (type === "prev") {
      return (
        <div className="control-btn">
          <img src={PreviousIcon} alt="prev" />
        </div>
      );
    }
    if (type === "next") {
      return (
        <div className="control-btn">
          <img src={NextIcon} alt="next" />
        </div>
      );
    }
    return originalElement;
  };
  